import { email, required, useGetIdentity, useRecordContext } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";

import type { Sale, SalesRole } from "../types";

const ASSIGNABLE_ROLES: SalesRole[] = ["admin", "sales", "design"];

/**
 * Role select. Nobody changes their own role, and the owner role is neither
 * offered nor editable (it is only shown, read-only, on the owner's record).
 */
export function RoleInput() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  const isOwner = record?.role === "owner";
  const choices = (isOwner ? (["owner"] as SalesRole[]) : ASSIGNABLE_ROLES).map(
    (id) => ({ id, name: `resources.sales.roles.${id}` }),
  );
  return (
    <SelectInput
      source="role"
      choices={choices}
      defaultValue="sales"
      isRequired
      disabled={isOwner || (record != null && record.id === identity?.id)}
      helperText={false}
    />
  );
}

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  return (
    <div className="space-y-4 w-full">
      <TextInput source="first_name" validate={required()} helperText={false} />
      <TextInput source="last_name" validate={required()} helperText={false} />
      <TextInput
        source="email"
        validate={[required(), email()]}
        helperText={false}
      />
      <RoleInput />
      <BooleanInput
        source="disabled"
        readOnly={record?.id === identity?.id}
        helperText={false}
      />
    </div>
  );
}
